import React from "react";

import { StyledSVG } from "../StyledIcon";

export const LoopIcon = props => {
  const { iconColor, iconWidth, iconHeight } = props;

  return (
    <StyledSVG
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      viewBox="0 0 18 18"
      fill="none"
      {...props}
    >
      <path
        d="M12.0904 13.1429C13.3427 12.3904 14.2775 11.2067 14.7192 9.81404C15.1609 8.42135 15.0793 6.91533 14.4897 5.57853C13.9 4.24173 12.8428 3.16603 11.5165 2.55323C10.1901 1.94044 8.68576 1.83267 7.2856 2.25014C5.88545 2.66762 4.68573 3.58165 3.91155 4.82075C3.13736 6.05984 2.84191 7.53885 3.08062 8.98029C3.31934 10.4217 4.07581 11.7265 5.20811 12.6499C6.34042 13.5733 7.77074 14.0517 9.23073 13.9956"
        stroke={iconColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 12L10 14L8 16"
        stroke={iconColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </StyledSVG>
  );
};
